import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getExploreStocks } from "../service";
import { contains, isEmptyObj } from "utils";
import { ROW_NUMBERS } from "utils/constants";

export const useExploreStocks = ({
  search = "",
  category = [],
  subCategories = {},
  size = ROW_NUMBERS[0].value,
  sort = "",
  enabled = true,
} = {}) => {
  const { data, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useInfiniteQuery({
      queryKey: [
        "exploreStocks",
        search,
        category,
        JSON.stringify(subCategories),
        size,
        sort,
      ],
      queryFn: async ({ pageParam = 1 }) => {
        let otherParams = {};
        if (contains(category, "etf")) {
          otherParams = { etf: true };
        }

        if (!isEmptyObj(subCategories)) {
          otherParams = { ...otherParams, ...subCategories };
        }

        const params = {
          search,
          page: pageParam,
          size,
          ...(sort ? { sort } : {}),
          ...otherParams,
        };

        const response = await getExploreStocks(params);

        return {
          data: response.data,
          currentPage: pageParam,
          totalPages: response.total_pages,
          totalCount: response.total_count,
          hasRecords: response.data.length > 0,
        };
      },
      getNextPageParam: (lastPage) =>
        lastPage.currentPage < lastPage.totalPages
          ? lastPage.currentPage + 1
          : undefined,
      enabled,
    });

  const stocksData = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data?.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;

  return {
    isLoading,
    isFetchingNextPage,
    stocksData,
    totalPages,
    totalCount,
    currentPage,
    fetchNextPage,
    hasNextPage,
  };
};
